var hostname = window.location.hostname;
var isProd = hostname === 'qscy.qingcigame.com';
var disable = isProd ? false : true;
window.__bl = {
    config: {
        pid: "egrrccpv71@f96645307d637ee",
        appType: "web",
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        disabled: disable,
        environment: isProd ? 'prod' : 'local',
        page: window.pageName,
    }
}